// import LogRocket from 'logrocket';
import * as Sentry from '@sentry/browser';
import _isPlainObject from 'lodash/isPlainObject';

// import { isLogRocketDisabled } from 'utils/analytics';

export default function logError(error, extra) {
  // const disableLogRocket = isLogRocketDisabled();

  if (process.env.REACT_APP_MODE === 'DEVELOPMENT') {
    console.log('Log Error: ', error);
  }

  if (!_isPlainObject(extra)) {
    // if (!disableLogRocket) {
    //   LogRocket.captureException(error);
    // }
    Sentry.captureException(error);
  } else {
    // if (!disableLogRocket) {
    //   LogRocket.captureException(error, { extra });
    // }
    Sentry.withScope(scope => {
      Object.keys(extra).forEach(key => {
        scope.setExtra(key, extra[key]);
      });
      Sentry.captureException(error);
    });
  }
}
